import Image from "next/image";
import React from "react";

export default function CountryImage({ countryCode }) {
  const loader = ({ src, width, quality }) => {
    return `https://storage.googleapis.com/hcmp_static_dev/flags/${src}.png`;
  };
  const ImgSrc = countryCode?.toLowerCase();
  if (!ImgSrc) return null;
  return (
    <Image
      loader={loader}
      alt="country-flag"
      src={ImgSrc}
      height={25}
      width={25}
    />
  );
}
